import React, { useEffect, useState } from "react";
// import "./App.css";
import { Routing } from "./Routing";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { AppBar, Divider, Typography } from "@mui/material";
import {
  getDateForView,
  getFormattedDate,
} from "./components/utility/getFormattedDate";
import "./LoginStyles.css";
import { AppDownloadDialog } from "./components/pwaComponents/AppDownloadDialog";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme/theme";
import { AuthWrapper } from "./AuthWrapper";
Amplify.configure(awsExports);

const dateForView = getDateForView(getFormattedDate());

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [appDownloadDialogIsOn, setAppDownloadDialogIsOn] =
    useState<boolean>(false);

  // アプリのダウンロード状況を確認(chrome)
  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // setAppDownloadDialogIsOn(true);
    });
  }, []);

  // iOSの場合
  useEffect(() => {
    if (isIos() && !isInStandaloneMode()) {
      // setAppDownloadDialogIsOn(true);
    }
    // const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    // const isInStandalone =
    //   "standalone" in window.navigator && (window.navigator as any).standalone;
    // if (isIos && !isInStandalone) {
    //   // iOS Safari でスタンドアロンじゃなければ、自前ダイアログを表示
    //   setAppDownloadDialogIsOn(true);
    // }
  }, []);

  function isIos(): boolean {
    const ua = window.navigator.userAgent.toLowerCase();
    // iPhone・iPod・iPad、またはタッチ対応 Mac（iPadOS13+）
    return (
      /iphone|ipod|ipad/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
  }

  function isInStandaloneMode(): boolean {
    // iOS Safari （legacy）
    const nav = window.navigator as any;
    const standaloneLegacy = "standalone" in nav && nav.standalone;
    // Chromium-based / iOS14.3+ （Modern）
    const standaloneMQ = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    return standaloneLegacy || standaloneMQ;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div
        className="App"
        style={{
          textAlign: "left",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(to bottom right, #e0f8e9, #c6f0d5)",
        }}
      >
        <Authenticator loginMechanisms={["email"]} hideSignUp>
          {/* <div
            style={{
              flex: 1,
              borderRadius: "5px",
              display: "flex",
              flexDirection: "column",
            }}
          > */}
          {/* <Routing /> */}
          <AuthWrapper />
          {/* </div> */}
        </Authenticator>
      </div>
    </ThemeProvider>
  );
}

export default App;
